import { useState } from 'react';
import { EnvelopeSimple, X } from '@phosphor-icons/react';
import { Button, Text, Flex } from '@chatsdet/ui';

export function LocalEmailHintBanner() {
  const [dismissed, setDismissed] = useState(false);
  if (dismissed) return null;

  return (
    <div className="absolute top-12 left-0 right-0 z-30 bg-blue-500/15 backdrop-blur-sm border-b border-blue-500/20 text-blue-900 dark:text-blue-100">
      <Flex align="start" gap="sm" className="px-3 py-2">
        <EnvelopeSimple size={14} className="shrink-0 opacity-80 mt-0.5" />
        <Text size="xs" className="flex-1">
          <strong>Notification node detected.</strong> Local email is mocked. To send real mail via prod SES, add to <code>apps/api/.env</code>: <code>EMAIL_MOCK_ENABLED=false</code>, <code>EMAIL_AWS_PROFILE=treebeard-production</code>, <code>EMAIL_FROM_ADDRESS=noreply@runcofactor.com</code> — then <code>aws sso login --profile treebeard-production</code> and restart the API.
        </Text>
        <Button
          variant="icon"
          size="sm"
          iconOnly
          tooltip="Dismiss"
          aria-label="Dismiss"
          onPress={() => setDismissed(true)}
        >
          <X size={12} />
        </Button>
      </Flex>
    </div>
  );
}
